import {Directive, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';

@Directive({
  selector: '[clickOutside]'
})
export class ClickOutsideDirective {
  @Input() clickOutsideEnabled: boolean = true;

  constructor(private elementRef: ElementRef) { }

  @Output() clickOutside = new EventEmitter<MouseEvent>();

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!this.clickOutsideEnabled){
      return;
    }

    if (!targetElement) {
      return;
    }
    if (targetElement === this.elementRef.nativeElement){
      return;
    }
    const clickedInside = this.checkParent(targetElement);
    if (!clickedInside) {
      this.clickOutside.emit(event);
    }
  }

  private checkParent(currentElement: HTMLElement): boolean {
    const parent = currentElement.parentElement;
    if (!parent || parent.nodeName === 'BODY' || parent.nodeName === 'HTML'){
      return false;
    }
    else if (parent === this.elementRef.nativeElement) {
      return true;
    }

    return this.checkParent(parent);
  }
}
